module.exports = __webpack_public_path__ + "static/img/cover17.6904e776.jpg";